/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { FormattedMessage } from 'react-intl';
import AuthenticateButton from 'components/ChoreoSystem/Authenticate/AuthenticateButton/AuthenticateButton';
import { ReactComponent as MicrosoftIcon } from 'components/ChoreoSystem/Images/Brands/Microsoft.svg';
import { emailLoginConfigs } from 'config';

interface MicrosoftLoginButtonProps {
  onClick: () => void;
}

export default function MicrosoftLoginButton(props: MicrosoftLoginButtonProps) {
  const { onClick } = props;

  const ButtonText = () => {
    if (emailLoginConfigs.ENABLE_EMAIL_LOGIN === 'true') {
      return (
        <FormattedMessage
          id="modules.login.buttons.microsoftLoginButton.microsoftLoginButton.continue.withMicrosoft"
          defaultMessage="Continue with Microsoft"
        />
      );
    }
    return (
      <FormattedMessage
        id="modules.login.buttons.googleLoginButton.googleLoginButton.signIn.withMicrosoft"
        defaultMessage="Sign in with Microsoft"
      />
    );
  };

  return (
    <AuthenticateButton
      testId="microsoft-sign-in"
      onClick={onClick}
      startIcon={<MicrosoftIcon fontSize="inherit" />}
    >
      {ButtonText()}
    </AuthenticateButton>
  );
}
